// eslint-disable-next-line no-restricted-imports
import { kebabCase } from 'lodash'

export const convertToSlug = (input: string): string => {
  return kebabCase(input.toLowerCase())
}
